export const box  = {
    display:'flex', 
    flexDirection:'column'
}
export const typo = {
    fontWeight: '500', 
    mb: '8px'
}
export const text = {
    mb:'20px'
}